export default {
  beforeRouteLeave(to, from, next) {
    this.$sn.assembly.loading(false);
    this.$sn.vuex.set('vuex_toast', {});
    this.$sn.vuex.set('vuex_modal', {});
    next();
  }
};
